// src/usePageView.ts
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function usePageView() {
  const location = useLocation();

  useEffect(() => {
    const pagePath = location.pathname + location.search;
    const win = window as any;
    
    // Log para depuración
    console.log("📄 usePageView: Cambio de ruta detectado:", pagePath);
    console.log("📄 usePageView: gtag disponible?", !!win.gtag);
    console.log("📄 usePageView: GA_MEASUREMENT_ID =", GA_MEASUREMENT_ID);

    if (!GA_MEASUREMENT_ID) {
      console.warn("⚠️ usePageView: GA_MEASUREMENT_ID no definido");
      return;
    }

    // Función para enviar el pageview
    const sendPageView = () => {
      if (!win.gtag) {
        console.warn("⚠️ usePageView: gtag no está disponible");
        return false;
      }

      // Verificar que el script oficial de Google esté cargado
      const scriptLoaded = document.querySelector('script[src*="www.googletagmanager.com/gtag/js"]');
      if (!scriptLoaded) {
        console.warn("⚠️ usePageView: Script de GA4 no está cargado aún");
        return false;
      }

      try {
        const dataLayerLengthBefore = win.dataLayer?.length || 0;
        
        // Enviar pageview usando el método correcto de GA4
        win.gtag("config", GA_MEASUREMENT_ID, {
          page_path: pagePath,
          page_title: document.title,
        });
        
        const dataLayerLengthAfter = win.dataLayer?.length || 0;
        
        console.log("✅ usePageView: Pageview enviado para:", pagePath);
        console.log("📊 usePageView: dataLayer length =", dataLayerLengthAfter);
        
        // Verificar que el evento se agregó al dataLayer
        if (win.dataLayer && win.dataLayer.length > 0) {
          const lastEvent = win.dataLayer[win.dataLayer.length - 1];
          console.log("📊 usePageView: Último evento en dataLayer:", lastEvent);
          
          // Verificar que el evento tenga el formato correcto
          // gtag puede agregar eventos en diferentes formatos, no todos son arrays
          if (Array.isArray(lastEvent)) {
            if (lastEvent[0] === "config" || lastEvent[0] === "event") {
              console.log("✅ usePageView: Formato de evento correcto");
            } else {
              // Otros tipos de eventos también son válidos
              console.log("ℹ️ usePageView: Evento de tipo:", lastEvent[0]);
            }
          } else if (typeof lastEvent === 'object' && lastEvent !== null) {
            // Los eventos también pueden ser objetos, esto es normal
            console.log("ℹ️ usePageView: Evento como objeto (formato válido)");
          } else {
            // Solo advertir si realmente es un formato inesperado
            console.warn("⚠️ usePageView: Formato de evento inesperado:", typeof lastEvent);
          }
        }
        
        // Verificar después de un momento si se procesó el evento
        setTimeout(() => {
          console.log("🔍 usePageView: Verificando procesamiento del evento...");
          console.log("💡 Tip: Abre Network > Filtra por 'collect' o 'google-analytics'");
          console.log("   Deberías ver peticiones a www.google-analytics.com/g/collect");
        }, 500);
        
        return true;
      } catch (error) {
        console.error("❌ usePageView: Error al enviar pageview:", error);
        return false;
      }
    };

    // Intentar enviar inmediatamente
    if (win.gtag) {
      sendPageView();
    } else {
      console.warn("⚠️ usePageView: gtag no está disponible aún. Esperando...");
      // Intentar de nuevo después de un breve delay
      const timeout = setTimeout(() => {
        if (win.gtag) {
          console.log("✅ usePageView: gtag ahora disponible, enviando pageview...");
          sendPageView();
        } else {
          console.error("❌ usePageView: gtag aún no está disponible después del timeout");
        }
      }, 1000); // Aumentar el timeout a 1 segundo
      
      return () => clearTimeout(timeout);
    }
  }, [location]);
}

